import { sendRequest } from 'api/sendRequest';
import { AGENDA_CONDITIONS_TYPE } from 'screens/oneOnOneRabbit/SettingsPage/constants';
import { AdminAgendaType } from 'screens/oneOnOneRabbit/SettingsPage/interfaces/AdminAgenda';

import { endpoints } from 'constants/endpoints';

export const getRegularTemplateAgendaApi = () => {
  const url = endpoints.oneOnOneRevamped.settings.regularTemplateAgenda;
  //   @ts-ignore
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
  });
};

export const getEventTemplateAgendaApi = () => {
  const url = endpoints.oneOnOneRevamped.settings.eventTemplateAgenda;
  //   @ts-ignore
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
  });
};

export const createUpdateTemplateAgendaApi = ({
  agendaList,
  agendaCondition,
}: {
  agendaList: AdminAgendaType[];
  agendaCondition: AGENDA_CONDITIONS_TYPE;
}) => {
  const url = endpoints.oneOnOneRevamped.settings.createUpdateTemplateAgenda;
  //   @ts-ignore
  return sendRequest({
    url,
    method: 'PUT',
    credentials: 'include',
    body: agendaList,
    queryParams: {
      agendaCondition,
    },
  });
};

export const getTemplateAgendaCountApi = ({ agendaCondition }: { agendaCondition: AGENDA_CONDITIONS_TYPE }) => {
  const url = endpoints.oneOnOneRevamped.settings.templateAgendaCount;
  //   @ts-ignore
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      agendaCondition,
    },
  });
};

export const deleteTemplateAgendaApi = ({ agendaId }: { agendaId: string | number }) => {
  const url = endpoints.oneOnOneRevamped.settings.deleteTemplateAgenda(agendaId);
  //   @ts-ignore
  return sendRequest({
    url,
    method: 'DELETE',
    credentials: 'include',
  });
};

export const deleteTemplateEventApi = ({ eventIdToBeDeleted }: { eventIdToBeDeleted: AGENDA_CONDITIONS_TYPE }) => {
  const url = endpoints.oneOnOneRevamped.settings.deleteAgendaCondition;
  //   @ts-ignore
  return sendRequest({
    url,
    method: 'DELETE',
    credentials: 'include',
    queryParams: {
      agendaCondition: eventIdToBeDeleted,
    },
  });
};
